import { onReady } from './utils/on-ready';
import { onWindowResize } from './utils/window-resize';
import { isTouch, initVhUnitOverwrite } from './utils/helpers';
import { initAnchorScroll } from './utils/scroll';
import { setupNavigation } from './layout/navigation';
import { calculateIframeSize } from './components/iframe-resize';
import { setupLanguageSelector } from './components/language-selector';
import { setupVimeoVideos } from './components/vimeo-video';
import { setupInvestmentList } from './modules/investment-list';
// import { setupThemeSwitcher } from './components/theme-switcher';

function init() {

    setTimeout(() => {
        document.body.classList.remove('standby');
    }, 0);

    if (isTouch) {
        document.body.classList.add('touch-device');
    }

    onReady(() => {
        initVhUnitOverwrite(calculateIframeSize);
        initAnchorScroll();
        setupNavigation();
        setupLanguageSelector();
        setupVimeoVideos();
        setupInvestmentList();

        // Only use this during test-mode c'')
        // setupThemeSwitcher();
    });

    onWindowResize(() => {
        calculateIframeSize();
    });
}

init();
